export const translations = {
  fr: {
    nav: { expertise: "Expertise", services: "Services", langues: "Langues", apropos: "À propos", devis: "Demander un devis" },
    hero: {
      eyebrow: "Experte près la Cour d'Appel de Rouen",
      line1: "Traduction &", line2: "Interprétation", line3: "certifiée",
      cta: "Demander un devis",
    },
    expertise: {
      label: "Expertise",
      titleA: "La parole donnée devant la justice exige une", titleB: "précision absolue.",
      p1a: "Traductrice et interprète ", p1bold: "experte près la Cour d'Appel de Rouen",
      p1b: ", j'assure depuis 2010 des traductions certifiées et des prestations d'interprétation reconnues par les juridictions, les notaires et les administrations.",
      p2: "Chaque document officiel — jugement, acte d'état civil, diplôme, dossier juridique — est traduit avec la rigueur qu'exige sa valeur probante, et revêtu de ma signature d'experte certifiée.",
      list: ["Cour d'Appel de Rouen", "Tribunaux judiciaires", "Notaires & avocats", "Préfectures & administrations"],
      caption: "Depuis 2010 — Rouen, Normandie",
    },
    services: {
      label: "Services", title: "Quatre domaines, une même exigence.",
      items: [
        { title: "Traduction certifiée", text: "Actes d'état civil, jugements, diplômes, contrats, dossiers d'immigration. Documents certifiés conformes, acceptés par toutes les administrations françaises et étrangères." },
        { title: "Interprétation judiciaire", text: "Audiences, gardes à vue, confrontations, assistance aux audiences correctionnelles et devant les cours. Présence discrète et exactitude irréprochable." },
        { title: "Interprétation de liaison", text: "Rendez-vous notariés, mariages, entretiens administratifs, réunions d'affaires. Un pont linguistique clair entre tous les interlocuteurs." },
        { title: "Traduction libre", text: "Documents commerciaux, correspondances, contenus techniques ou personnels, avec le même soin rédactionnel que mes traductions certifiées." },
      ],
      cta: "Demander un devis →",
    },
    languages: {
      label: "Langues", title: "Quatre langues, deux cultures, une seule voix.",
      notes: { fr: "Langue de travail et d'expertise", en: "Traduction & interprétation", ru: "Langue maternelle", ua: "Langue maternelle" },
      p: "De culture russe et ukrainienne, installée en France depuis de longues années, je travaille dans les deux sens de la combinaison linguistique, à l'écrit comme à l'oral.",
    },
    zone: {
      label: "Zone d'intervention",
      titleA: "Basée près de Rouen,", titleB: "en déplacement sur toute la France.",
      p: "Audiences, signatures chez le notaire, rendez-vous en préfecture ou en mairie : je me déplace partout en France pour vos besoins d'interprétation. Les traductions, elles, sont traitées à distance et envoyées par courrier suivi ou remises en main propre.",
      zones: ["Rouen & Normandie", "Paris & Île-de-France", "Toute la France"],
    },
    about: {
      label: "À propos",
      quoteA: "« Traduire, c'est faire passer le sens sans jamais trahir ", quoteB: "l'intention", quoteC: ". »",
      p1: "Née dans une culture où le russe et l'ukrainien se côtoient, j'ai fait de la langue française ma langue professionnelle. Cette double appartenance est au cœur de mon travail : comprendre ce qui se dit, mais aussi ce qui se tait.",
      p2: "Experte inscrite près la Cour d'Appel de Rouen, je mets cette sensibilité au service des particuliers, des avocats, des notaires et des institutions — avec la confidentialité et la rigueur qu'impose le serment d'expert.",
      alt: "Oléna Gurova-Vacher, traductrice interprète experte",
    },
    quote: {
      label: "Demande de devis",
      titleA: "Décrivez votre besoin, je réponds", titleB: "sous 24 à 48h.",
      sub: "Devis gratuit et sans engagement. Pour les traductions urgentes ou les audiences, privilégiez le téléphone.",
      form: {
        name: "Nom complet *", namePh: "Votre nom",
        email: "Email *", emailPh: "vous@exemple.fr",
        phone: "Téléphone", phonePh: "06 00 00 00 00",
        service: "Prestation *", choose: "Sélectionnez",
        services: ["Traduction certifiée", "Interprétation (audience, rendez-vous)", "Traduction libre", "Autre demande"],
        languages: "Combinaison de langues *",
        langs: ["Français ⇄ Russe", "Français ⇄ Ukrainien", "Français ⇄ Anglais", "Autre combinaison"],
        message: "Votre demande *", messagePh: "Nature des documents, délais, lieu de l'audience ou du rendez-vous…",
        files: "Documents à traduire (PDF, images, Word — 10 Mo max)",
        filesHint: "Actes, jugements, diplômes…",
        submit: "Envoyer ma demande", sending: "Envoi en cours…",
        privacy: "Vos données ne sont utilisées que pour répondre à votre demande. Elles ne sont ni cédées, ni conservées à d'autres fins.",
        success: "Votre demande de devis a bien été envoyée. Réponse sous 24 à 48h.",
        error: "Une erreur est survenue. Merci de réessayer.",
        tooBig: "La taille totale des fichiers dépasse 10 Mo.",
      },
    },
    footer: {
      contact: "Contact", expertise: "Expertise", infos: "Informations",
      expertiseLines: ["Traductrice interprète experte", "Cour d'Appel de Rouen", "Français · Anglais · Russe · Ukrainien"],
      legal: "Mentions légales", admin: "Espace professionnel", rights: "Tous droits réservés.",
    },
    legal: {
      back: "Retour au site", eyebrow: "Informations réglementaires", title: "Mentions légales",
      sections: [
        { title: "Éditrice du site", body: [
          "Madame Oléna GUROVA-VACHER — Entrepreneur individuel",
          "Activité : Traduction et interprétation (Code NAF/APE 74.30Z)",
          "SIREN : 523 682 490 — SIRET (siège) : 523 682 490 00017",
          "N° TVA intracommunautaire : FR77523682490",
          "Inscrite au RNE depuis le 15/06/2010",
          "Adresse : Résidence de la Hêtraie, Imm. Drakkar, 3 rue Lefort Gonssolin, 76130 Mont-Saint-Aignan",
          "Téléphone : +33 (0)6 07 27 84 28",
          "Email : olena.gurova@gmail.com",
        ]},
        { title: "Directrice de la publication", body: ["Madame Oléna GUROVA-VACHER."] },
        { title: "Données personnelles", body: [
          "Les informations transmises via le formulaire de contact (nom, email, téléphone, contenu de la demande) sont utilisées exclusivement pour répondre à votre demande de devis. Elles ne font l'objet d'aucune cession à des tiers ni d'aucune prospection commerciale.",
          "Conformément au Règlement (UE) 2016/679 (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer : olena.gurova@gmail.com.",
        ]},
        { title: "Propriété intellectuelle", body: [
          "L'ensemble des contenus de ce site (textes, visuels, mise en page) est protégé par le droit d'auteur. Toute reproduction sans autorisation écrite préalable est interdite.",
        ]},
      ],
    },
    admin: {
      space: "Espace professionnel", login: "Connexion", email: "Email", password: "Mot de passe",
      submit: "Se connecter", back: "Retour au site", error: "Connexion impossible.",
      titleA: "Demandes de", titleB: "devis", viewSite: "Voir le site", logout: "Déconnexion",
      empty: "Aucune demande pour le moment.", new: "Nouvelle", done: "Traitée",
      markDone: "Traiter", reopen: "Rouvrir",
      markedDone: "Demande marquée comme traitée.", reopened: "Demande rouverte.", updateError: "Mise à jour impossible.",
      attachments: "Pièces jointes", download: "Télécharger",
    },
  },

  en: {
    nav: { expertise: "Expertise", services: "Services", langues: "Languages", apropos: "About", devis: "Request a quote" },
    hero: {
      eyebrow: "Expert before the Rouen Court of Appeal",
      line1: "Translation &", line2: "interpreting —", line3: "sworn",
      cta: "Request a quote",
    },
    expertise: {
      label: "Expertise",
      titleA: "A word given before justice demands", titleB: "absolute precision.",
      p1a: "As a ", p1bold: "sworn translator and interpreter before the Rouen Court of Appeal",
      p1b: ", I have been providing certified translations and interpreting services recognised by courts, notaries and public authorities since 2010.",
      p2: "Every official document — judgment, civil status certificate, diploma, legal file — is translated with the rigour its probative value requires, and bears my signature as a sworn expert.",
      list: ["Rouen Court of Appeal", "Judicial courts", "Notaries & lawyers", "Prefectures & public authorities"],
      caption: "Since 2010 — Rouen, Normandy",
    },
    services: {
      label: "Services", title: "Four fields, one standard of excellence.",
      items: [
        { title: "Certified translation", text: "Civil status certificates, judgments, diplomas, contracts, immigration files. Certified documents accepted by all French and foreign authorities." },
        { title: "Court interpreting", text: "Hearings, police custody, confrontations, assistance before criminal courts. A discreet presence and irreproachable accuracy." },
        { title: "Liaison interpreting", text: "Notary appointments, weddings, administrative interviews, business meetings. A clear linguistic bridge between all parties." },
        { title: "Non-certified translation", text: "Business documents, correspondence, technical or personal content, with the same editorial care as my certified translations." },
      ],
      cta: "Request a quote →",
    },
    languages: {
      label: "Languages", title: "Four languages, two cultures, one voice.",
      notes: { fr: "Working and expert language", en: "Translation & interpreting", ru: "Native language", ua: "Native language" },
      p: "Raised between Russian and Ukrainian cultures and settled in France for many years, I work in both directions of each language pair, in writing and in speech.",
    },
    zone: {
      label: "Service area",
      titleA: "Based near Rouen,", titleB: "available throughout France.",
      p: "Hearings, signings at the notary's office, appointments at the prefecture or town hall: I travel anywhere in France for your interpreting needs. Translations are handled remotely and sent by tracked mail or delivered in person.",
      zones: ["Rouen & Normandy", "Paris & Île-de-France", "All of France"],
    },
    about: {
      label: "About",
      quoteA: "“To translate is to convey meaning without ever betraying ", quoteB: "the intention", quoteC: ".”",
      p1: "Born into a culture where Russian and Ukrainian coexist, I made French my professional language. This dual belonging is at the heart of my work: understanding what is said, but also what is left unsaid.",
      p2: "A sworn expert registered with the Rouen Court of Appeal, I put this sensitivity at the service of individuals, lawyers, notaries and institutions — with the confidentiality and rigour demanded by the expert's oath.",
      alt: "Oléna Gurova-Vacher, sworn translator and interpreter",
    },
    quote: {
      label: "Quote request",
      titleA: "Describe your need, I reply", titleB: "within 24–48h.",
      sub: "Free, no-obligation quote. For urgent translations or hearings, please call.",
      form: {
        name: "Full name *", namePh: "Your name",
        email: "Email *", emailPh: "you@example.com",
        phone: "Phone", phonePh: "+44 7000 000000",
        service: "Service *", choose: "Select",
        services: ["Certified translation", "Interpreting (hearing, appointment)", "Non-certified translation", "Other request"],
        languages: "Language pair *",
        langs: ["French ⇄ Russian", "French ⇄ Ukrainian", "French ⇄ English", "Other combination"],
        message: "Your request *", messagePh: "Type of documents, deadlines, place of hearing or appointment…",
        files: "Documents to translate (PDF, images, Word — 10 MB max)",
        filesHint: "Certificates, judgments, diplomas…",
        submit: "Send my request", sending: "Sending…",
        privacy: "Your data is used only to respond to your request. It is neither shared nor kept for any other purpose.",
        success: "Your quote request has been sent. Reply within 24–48h.",
        error: "An error occurred. Please try again.",
        tooBig: "Total file size exceeds 10 MB.",
      },
    },
    footer: {
      contact: "Contact", expertise: "Expertise", infos: "Information",
      expertiseLines: ["Sworn translator & interpreter", "Rouen Court of Appeal", "French · English · Russian · Ukrainian"],
      legal: "Legal notice", admin: "Professional area", rights: "All rights reserved.",
    },
    legal: {
      back: "Back to site", eyebrow: "Regulatory information", title: "Legal notice",
      sections: [
        { title: "Site publisher", body: [
          "Ms Oléna GUROVA-VACHER — Sole trader",
          "Activity: Translation and interpreting (NAF/APE code 74.30Z)",
          "SIREN: 523 682 490 — SIRET (head office): 523 682 490 00017",
          "Intra-community VAT no.: FR77523682490",
          "Registered with the RNE since 15/06/2010",
          "Address: Résidence de la Hêtraie, Imm. Drakkar, 3 rue Lefort Gonssolin, 76130 Mont-Saint-Aignan",
          "Phone: +33 (0)6 07 27 84 28",
          "Email: olena.gurova@gmail.com",
        ]},
        { title: "Publication director", body: ["Ms Oléna GUROVA-VACHER."] },
        { title: "Personal data", body: [
          "Information sent via the contact form (name, email, phone, request content) is used exclusively to respond to your quote request. It is never shared with third parties nor used for marketing.",
          "Under Regulation (EU) 2016/679 (GDPR), you have the right to access, rectify and delete your data. To exercise it: olena.gurova@gmail.com.",
        ]},
        { title: "Intellectual property", body: [
          "All content on this site (text, visuals, layout) is protected by copyright. Any reproduction without prior written permission is prohibited.",
        ]},
      ],
    },
    admin: {
      space: "Professional area", login: "Sign in", email: "Email", password: "Password",
      submit: "Sign in", back: "Back to site", error: "Connection failed.",
      titleA: "Quote", titleB: "requests", viewSite: "View site", logout: "Sign out",
      empty: "No requests yet.", new: "New", done: "Done",
      markDone: "Mark done", reopen: "Reopen",
      markedDone: "Request marked as done.", reopened: "Request reopened.", updateError: "Update failed.",
      attachments: "Attachments", download: "Download",
    },
  },

  ru: {
    nav: { expertise: "Экспертиза", services: "Услуги", langues: "Языки", apropos: "Обо мне", devis: "Запросить расчёт" },
    hero: {
      eyebrow: "Присяжный эксперт при Апелляционном суде Руана",
      line1: "Присяжный перевод", line2: "и устное", line3: "сопровождение",
      cta: "Запросить расчёт",
    },
    expertise: {
      label: "Экспертиза",
      titleA: "Слово, данное перед правосудием, требует", titleB: "абсолютной точности.",
      p1a: "Как ", p1bold: "присяжный переводчик при Апелляционном суде Руана",
      p1b: ", с 2010 года я выполняю присяжные переводы и услуги устного перевода, признанные судами, нотариусами и администрациями.",
      p2: "Каждый официальный документ — судебное решение, акт гражданского состояния, диплом, юридическое досье — переводится с той строгостью, которой требует его доказательная сила, и заверяется моей подписью присяжного эксперта.",
      list: ["Апелляционный суд Руана", "Судебные инстанции", "Нотариусы и адвокаты", "Префектуры и администрации"],
      caption: "С 2010 года — Руан, Нормандия",
    },
    services: {
      label: "Услуги", title: "Четыре направления — одна планка качества.",
      items: [
        { title: "Присяжный перевод", text: "Акты гражданского состояния, судебные решения, дипломы, договоры, иммиграционные досье. Заверенные документы, принимаемые всеми французскими и зарубежными администрациями." },
        { title: "Судебный устный перевод", text: "Слушания, задержания, очные ставки, сопровождение в уголовных судах. Незаметное присутствие и безупречная точность." },
        { title: "Устный перевод при встречах", text: "Визиты к нотариусу, бракосочетания, административные собеседования, деловые встречи. Надёжный языковой мост между всеми участниками." },
        { title: "Письменный перевод", text: "Деловые документы, переписка, технические или личные материалы — с той же редакторской тщательностью, что и присяжные переводы." },
      ],
      cta: "Запросить расчёт →",
    },
    languages: {
      label: "Языки", title: "Четыре языка, две культуры, один голос.",
      notes: { fr: "Рабочий язык и язык экспертизы", en: "Перевод и интерпретация", ru: "Родной язык", ua: "Родной язык" },
      p: "Выросшая в среде, где соседствуют русский и украинский, и много лет живущая во Франции, я работаю в обоих направлениях каждой языковой пары — письменно и устно.",
    },
    zone: {
      label: "География работы",
      titleA: "Живу под Руаном,", titleB: "выезжаю по всей Франции.",
      p: "Судебные слушания, подписания у нотариуса, визиты в префектуру или мэрию: я выезжаю в любую точку Франции для устного перевода. Письменные переводы выполняются дистанционно и отправляются заказным письмом или вручаются лично.",
      zones: ["Руан и Нормандия", "Париж и Иль-де-Франс", "Вся Франция"],
    },
    about: {
      label: "Обо мне",
      quoteA: "«Переводить — значит передать смысл, никогда не предавая ", quoteB: "намерение", quoteC: ".»",
      p1: "Рождённая в культуре, где русский и украинский существуют бок о бок, я сделала французский своим профессиональным языком. Эта двойная принадлежность — в сердце моей работы: понимать сказанное и невысказанное.",
      p2: "Присяжный эксперт, состоящая при Апелляционном суде Руана, я ставлю эту чуткость на службу частным лицам, адвокатам, нотариусам и учреждениям — с конфиденциальностью и строгостью, которых требует присяга эксперта.",
      alt: "Олена Гурова-Ваше, присяжный переводчик",
    },
    quote: {
      label: "Запрос расчёта",
      titleA: "Опишите вашу задачу — отвечу", titleB: "в течение 24–48 часов.",
      sub: "Бесплатный расчёт без обязательств. Для срочных переводов и слушаний лучше позвонить.",
      form: {
        name: "ФИО *", namePh: "Ваше имя",
        email: "Эл. почта *", emailPh: "vy@primer.ru",
        phone: "Телефон", phonePh: "+7 900 000-00-00",
        service: "Услуга *", choose: "Выберите",
        services: ["Присяжный перевод", "Устный перевод (слушание, встреча)", "Письменный перевод", "Другой запрос"],
        languages: "Языковая пара *",
        langs: ["Французский ⇄ Русский", "Французский ⇄ Украинский", "Французский ⇄ Английский", "Другая комбинация"],
        message: "Ваш запрос *", messagePh: "Тип документов, сроки, место слушания или встречи…",
        files: "Документы для перевода (PDF, изображения, Word — макс. 10 МБ)",
        filesHint: "Акты, судебные решения, дипломы…",
        submit: "Отправить запрос", sending: "Отправка…",
        privacy: "Ваши данные используются только для ответа на запрос. Они не передаются третьим лицам и не хранятся для иных целей.",
        success: "Ваш запрос отправлен. Ответ в течение 24–48 часов.",
        error: "Произошла ошибка. Пожалуйста, попробуйте ещё раз.",
        tooBig: "Общий размер файлов превышает 10 МБ.",
      },
    },
    footer: {
      contact: "Контакты", expertise: "Экспертиза", infos: "Информация",
      expertiseLines: ["Присяжный переводчик", "Апелляционный суд Руана", "Французский · Английский · Русский · Украинский"],
      legal: "Правовая информация", admin: "Личный кабинет", rights: "Все права защищены.",
    },
    legal: {
      back: "Назад на сайт", eyebrow: "Нормативная информация", title: "Правовая информация",
      sections: [
        { title: "Издатель сайта", body: [
          "Госпожа Олена ГУРОВА-ВАШЕ — индивидуальный предприниматель",
          "Деятельность: письменный и устный перевод (код NAF/APE 74.30Z)",
          "SIREN: 523 682 490 — SIRET (головной офис): 523 682 490 00017",
          "Номер НДС: FR77523682490",
          "Зарегистрирована в RNE с 15/06/2010",
          "Адрес: Résidence de la Hêtraie, Imm. Drakkar, 3 rue Lefort Gonssolin, 76130 Mont-Saint-Aignan",
          "Телефон: +33 (0)6 07 27 84 28",
          "Эл. почта: olena.gurova@gmail.com",
        ]},
        { title: "Директор публикации", body: ["Госпожа Олена ГУРОВА-ВАШЕ."] },
        { title: "Персональные данные", body: [
          "Данные, отправленные через контактную форму (имя, эл. почта, телефон, содержание запроса), используются исключительно для ответа на ваш запрос. Они не передаются третьим лицам и не используются в маркетинговых целях.",
          "В соответствии с Регламентом (ЕС) 2016/679 (GDPR) вы имеете право на доступ, исправление и удаление ваших данных: olena.gurova@gmail.com.",
        ]},
        { title: "Интеллектуальная собственность", body: [
          "Все материалы сайта (тексты, изображения, вёрстка) защищены авторским правом. Любое воспроизведение без письменного разрешения запрещено.",
        ]},
      ],
    },
    admin: {
      space: "Личный кабинет", login: "Вход", email: "Эл. почта", password: "Пароль",
      submit: "Войти", back: "Назад на сайт", error: "Не удалось войти.",
      titleA: "Запросы", titleB: "расчёта", viewSite: "Открыть сайт", logout: "Выйти",
      empty: "Пока нет запросов.", new: "Новый", done: "Обработан",
      markDone: "Обработать", reopen: "Открыть снова",
      markedDone: "Запрос отмечен как обработанный.", reopened: "Запрос открыт снова.", updateError: "Не удалось обновить.",
      attachments: "Вложения", download: "Скачать",
    },
  },

  ua: {
    nav: { expertise: "Експертиза", services: "Послуги", langues: "Мови", apropos: "Про мене", devis: "Запросити розрахунок" },
    hero: {
      eyebrow: "Присяжна експертка при Апеляційному суді Руана",
      line1: "Присяжний переклад", line2: "та усний", line3: "переклад",
      cta: "Запросити розрахунок",
    },
    expertise: {
      label: "Експертиза",
      titleA: "Слово, дане перед правосуддям, вимагає", titleB: "абсолютної точності.",
      p1a: "Як ", p1bold: "присяжна перекладачка при Апеляційному суді Руана",
      p1b: ", з 2010 року я виконую присяжні переклади та послуги усного перекладу, визнані судами, нотаріусами та адміністраціями.",
      p2: "Кожен офіційний документ — судове рішення, акт цивільного стану, диплом, юридичне досьє — перекладається з тією ретельністю, якої вимагає його доказова сила, і засвідчується моїм підписом присяжної експертки.",
      list: ["Апеляційний суд Руана", "Судові інстанції", "Нотаріуси та адвокати", "Префектури та адміністрації"],
      caption: "З 2010 року — Руан, Нормандія",
    },
    services: {
      label: "Послуги", title: "Чотири напрямки — одна планка якості.",
      items: [
        { title: "Присяжний переклад", text: "Акти цивільного стану, судові рішення, дипломи, договори, імміграційні досьє. Засвідчені документи, які приймають усі французькі та закордонні адміністрації." },
        { title: "Судовий усний переклад", text: "Слухання, затримання, очні ставки, супровід у кримінальних судах. Непомітна присутність і бездоганна точність." },
        { title: "Усний переклад на зустрічах", text: "Візити до нотаріуса, весілля, адміністративні співбесіди, ділові зустрічі. Надійний мовний міст між усіма учасниками." },
        { title: "Письмовий переклад", text: "Ділові документи, листування, технічні чи особисті матеріали — з тією самою редакторською ретельністю, що й присяжні переклади." },
      ],
      cta: "Запросити розрахунок →",
    },
    languages: {
      label: "Мови", title: "Чотири мови, дві культури, один голос.",
      notes: { fr: "Робоча мова та мова експертизи", en: "Переклад та інтерпретація", ru: "Рідна мова", ua: "Рідна мова" },
      p: "Зросла у середовищі, де поруч російська та українська, і багато років живу у Франції — я працюю в обох напрямках кожної мовної пари, письмово та усно.",
    },
    zone: {
      label: "Географія роботи",
      titleA: "Мешкаю поблизу Руана,", titleB: "виїжджаю по всій Франції.",
      p: "Судові слухання, підписання у нотаріуса, візити до префектури чи мерії: я виїжджаю в будь-який куточок Франції для усного перекладу. Письмові переклади виконуються дистанційно й надсилаються рекомендованим листом або вручаються особисто.",
      zones: ["Руан і Нормандія", "Париж та Іль-де-Франс", "Вся Франція"],
    },
    about: {
      label: "Про мене",
      quoteA: "«Перекладати — це передати зміст, ніколи не зраджуючи ", quoteB: "намір", quoteC: ".»",
      p1: "Народжена в культурі, де російська та українська існують пліч-о-пліч, я зробила французьку своєю професійною мовою. Ця подвійна належність — у серці моєї роботи: розуміти сказане й несказане.",
      p2: "Присяжна експертка при Апеляційному суді Руана, я ставлю цю чутливість на службу приватним особам, адвокатам, нотаріусам та установам — з конфіденційністю й ретельністю, яких вимагає присяга експерта.",
      alt: "Олена Гурова-Ваше, присяжна перекладачка",
    },
    quote: {
      label: "Запит розрахунку",
      titleA: "Опишіть ваше завдання — відповім", titleB: "протягом 24–48 годин.",
      sub: "Безкоштовний розрахунок без зобов'язань. Для термінових перекладів і слухань краще зателефонувати.",
      form: {
        name: "ПІБ *", namePh: "Ваше ім'я",
        email: "Ел. пошта *", emailPh: "vy@pryklad.ua",
        phone: "Телефон", phonePh: "+380 00 000 00 00",
        service: "Послуга *", choose: "Оберіть",
        services: ["Присяжний переклад", "Усний переклад (слухання, зустріч)", "Письмовий переклад", "Інший запит"],
        languages: "Мовна пара *",
        langs: ["Французька ⇄ Російська", "Французька ⇄ Українська", "Французька ⇄ Англійська", "Інша комбінація"],
        message: "Ваш запит *", messagePh: "Тип документів, терміни, місце слухання або зустрічі…",
        files: "Документи для перекладу (PDF, зображення, Word — макс. 10 МБ)",
        filesHint: "Акти, судові рішення, дипломи…",
        submit: "Надіслати запит", sending: "Надсилання…",
        privacy: "Ваші дані використовуються лише для відповіді на запит. Вони не передаються третім особам і не зберігаються для інших цілей.",
        success: "Ваш запит надіслано. Відповідь протягом 24–48 годин.",
        error: "Сталася помилка. Будь ласка, спробуйте ще раз.",
        tooBig: "Загальний розмір файлів перевищує 10 МБ.",
      },
    },
    footer: {
      contact: "Контакти", expertise: "Експертиза", infos: "Інформація",
      expertiseLines: ["Присяжна перекладачка", "Апеляційний суд Руана", "Французька · Англійська · Російська · Українська"],
      legal: "Правова інформація", admin: "Особистий кабінет", rights: "Усі права захищено.",
    },
    legal: {
      back: "Назад на сайт", eyebrow: "Нормативна інформація", title: "Правова інформація",
      sections: [
        { title: "Видавець сайту", body: [
          "Пані Олена ГУРОВА-ВАШЕ — фізична особа-підприємець",
          "Діяльність: письмовий та усний переклад (код NAF/APE 74.30Z)",
          "SIREN: 523 682 490 — SIRET (головний офіс): 523 682 490 00017",
          "Номер ПДВ: FR77523682490",
          "Зареєстрована в RNE з 15/06/2010",
          "Адреса: Résidence de la Hêtraie, Imm. Drakkar, 3 rue Lefort Gonssolin, 76130 Mont-Saint-Aignan",
          "Телефон: +33 (0)6 07 27 84 28",
          "Ел. пошта: olena.gurova@gmail.com",
        ]},
        { title: "Директор публікації", body: ["Пані Олена ГУРОВА-ВАШЕ."] },
        { title: "Персональні дані", body: [
          "Дані, надіслані через контактну форму (ім'я, ел. пошта, телефон, зміст запиту), використовуються виключно для відповіді на ваш запит. Вони не передаються третім особам і не використовуються в маркетингових цілях.",
          "Відповідно до Регламенту (ЄС) 2016/679 (GDPR) ви маєте право на доступ, виправлення та видалення ваших даних: olena.gurova@gmail.com.",
        ]},
        { title: "Інтелектуальна власність", body: [
          "Усі матеріали сайту (тексти, зображення, верстання) захищені авторським правом. Будь-яке відтворення без письмового дозволу заборонене.",
        ]},
      ],
    },
    admin: {
      space: "Особистий кабінет", login: "Вхід", email: "Ел. пошта", password: "Пароль",
      submit: "Увійти", back: "Назад на сайт", error: "Не вдалося увійти.",
      titleA: "Запити", titleB: "розрахунку", viewSite: "Відкрити сайт", logout: "Вийти",
      empty: "Поки немає запитів.", new: "Новий", done: "Опрацьовано",
      markDone: "Опрацювати", reopen: "Відкрити знову",
      markedDone: "Запит позначено як опрацьований.", reopened: "Запит відкрито знову.", updateError: "Не вдалося оновити.",
      attachments: "Вкладення", download: "Завантажити",
    },
  },
};
